<template>
  <div class="bg-gray-100 dark:bg-gray-700 px-6 py-3 flex mt-5">
    <slot />
  </div>
</template>

<script>
export default {
  //
}
</script>
